import useAuth from "hooks/useAuth";
import ExternalLogin from "pages/authentication/ExternalLogin";
import Plan from "pages/authentication/Plan";
import { Fragment, ReactNode, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// component props interface
interface AuthGuardProps {
  children: ReactNode;
}

const ExternalAuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    return <ExternalLogin />;
  }

  if (
    !user!!.isDevAccount &&
    (user!!.planEditionType === null ||
      user!!.planEditionType === undefined ||
      user!!.planStatus !== "active")
  ) {
    if (user!!.userType !== "CUSTOMER") return <Plan />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  return <Fragment>{children}</Fragment>;
};

export default ExternalAuthGuard;
